import { gql } from '@apollo/client'

const dfmFeedbackQuery = gql`
    query dfmFeedbackImDfmModal($dfmFeedbackId: UUID!) {
        dfmFeedback(id: $dfmFeedbackId) {
            id
            attachment {
                id
            }
        }
    }
`

export default dfmFeedbackQuery
